<template>
    <div class="m-c-list-filter">
        <!--
            uses exi website icon, typo and button classes (no prefix 'm-')!
            fonts will be overridden by the exi website styles
        -->
        <h2 class="m-c-list-filter__headline u-typo:xxl u-typo:regular2">
            {{ $t.message("searchAndFilterProjects") }}
        </h2>

        <form
            @submit.prevent
            class="m-c-list-filter__form m-c-form"
            action="#"
            method="post"
        >
            <!-- countries -->
            <div class="m-c-form__group">
                <span
                    class="m-c-form__label u-typo:bold"
                    id="dropdown-countries"
                >
                    {{ $t.message("destinationCountry") }}:
                </span>
                <div
                    class="m-c-dropdown"
                    :class="filterElements.countries === true ? `active` : ``"
                >
                    <!--
                        open only one at a time, close on escape key
                        if open: add active class on m-c-dropdown + set aria-expanded="true"
                        match attributes: .m-c-form__label id and button aria-labelledby
                        match attributes: .m-c-dropdown__list id and button aria-controls
                    -->
                    <button
                        class="m-c-dropdown__button c-button"
                        type="button"
                        aria-controls="dropdown-list-countries"
                        :aria-expanded="
                            filterElements.countries === true ? `true` : `false`
                        "
                        aria-labelledby="dropdown-countries"
                        @click="
                            closeDropdowns('countries');
                            filterElements.countries =
                                !filterElements.countries;
                        "
                    >
                        <span>{{
                            appliedFilterLabels.countries ||
                            $t.message("choose")
                        }}</span>
                        <i
                            class="o-icon-font o-icon-font--arrow-down"
                            aria-hidden="true"
                        ></i>
                    </button>
                    <ul class="m-c-dropdown__list" id="dropdown-list-countries">
                        <li
                            v-for="(country, index) in filterData.countries"
                            :key="country.id"
                            class="m-c-dropdown__item"
                        >
                            <div class="m-c-form__checkfields">
                                <input
                                    :id="`checkbox-country-${index + 1}`"
                                    type="checkbox"
                                    name="checkbox-countries"
                                    :checked="
                                        appliedFilterIDs.countries
                                            .split(',')
                                            .includes(country.id)
                                            ? `checked`
                                            : false
                                    "
                                    v-on:change="
                                        setFilter({
                                            filter: `countries`,
                                            filterID: country.id,
                                            filterLabel: country.label,
                                            checked: $event.target.checked,
                                        })
                                    "
                                />
                                <label :for="`checkbox-country-${index + 1}`"
                                    >{{ country.label }}
                                </label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- topics -->
            <div class="m-c-form__group">
                <span class="m-c-form__label u-typo:bold" id="dropdown-topics">
                    {{ $t.message("topic") }}:
                </span>
                <div
                    class="m-c-dropdown"
                    :class="filterElements.topics === true ? `active` : ``"
                >
                    <!--
                        open only one at a time, close on escape key
                        if open: add active class on m-c-dropdown + set aria-expanded="true"
                        match attributes: .m-c-form__label id and button aria-labelledby
                        match attributes: .m-c-dropdown__list id and button aria-controls
                    -->
                    <button
                        class="m-c-dropdown__button c-button"
                        type="button"
                        aria-controls="dropdown-list-topics"
                        :aria-expanded="
                            filterElements.topics === true ? `true` : `false`
                        "
                        aria-labelledby="dropdown-topics"
                        @click="
                            closeDropdowns('topics');
                            filterElements.topics = !filterElements.topics;
                        "
                    >
                        <span>{{
                            appliedFilterLabels.topics || $t.message("choose")
                        }}</span>
                        <i
                            class="o-icon-font o-icon-font--arrow-down"
                            aria-hidden="true"
                        ></i>
                    </button>
                    <ul class="m-c-dropdown__list" id="dropdown-list-topics">
                        <li
                            v-for="(topic, index) in filterData.topics"
                            :key="topic.id"
                            class="m-c-dropdown__item"
                        >
                            <div class="m-c-form__checkfields">
                                <input
                                    :id="`checkbox-topic-${index + 1}`"
                                    type="checkbox"
                                    name="checkbox-topics"
                                    :checked="
                                        appliedFilterIDs.topics.includes(
                                            topic.id
                                        )
                                            ? `checked`
                                            : false
                                    "
                                    v-on:change="
                                        setFilter({
                                            filter: `topics`,
                                            filterID: topic.id,
                                            filterLabel: topic.label,
                                            checked: $event.target.checked,
                                        })
                                    "
                                />
                                <label :for="`checkbox-topic-${index + 1}`"
                                    >{{ topic.label }}
                                </label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- state -->
            <div class="m-c-form__group">
                <span class="m-c-form__label u-typo:bold" id="dropdown-state">
                    {{ $t.message("projectStatus") }}:
                </span>
                <div
                    class="m-c-dropdown"
                    :class="filterElements.status === true ? `active` : ``"
                >
                    <!--
                        open only one at a time, close on escape key
                        if open: add active class on m-c-dropdown + set aria-expanded="true"
                        match attributes: .m-c-form__label id and button aria-labelledby
                        match attributes: .m-c-dropdown__list id and button aria-controls
                    -->
                    <button
                        class="m-c-dropdown__button c-button"
                        type="button"
                        aria-controls="dropdown-list-state"
                        :aria-expanded="
                            filterElements.status === true ? `true` : `false`
                        "
                        aria-labelledby="dropdown-state"
                        @click="
                            closeDropdowns('status');
                            filterElements.status = !filterElements.status;
                        "
                    >
                        <span v-if="appliedFilterLabels.status == `ongoing`">{{
                            $t.message("statusOngoing")
                        }}</span>
                        <span v-if="appliedFilterLabels.status == `closed`">{{
                            $t.message("statusCompleted")
                        }}</span>
                        <span v-if="!appliedFilterLabels.status">{{
                            $t.message("choose")
                        }}</span>
                        <span
                            v-if="
                                appliedFilterLabels.status ==
                                    `ongoing, closed` ||
                                appliedFilterLabels.status == `closed, ongoing`
                            "
                        >
                            {{ $t.message("statusOngoing") }},
                            {{ $t.message("statusCompleted") }}
                        </span>
                        <i
                            class="o-icon-font o-icon-font--arrow-down"
                            aria-hidden="true"
                        ></i>
                    </button>
                    <ul class="m-c-dropdown__list" id="dropdown-list-state">
                        <!--
                            options:
                            laufend
                            abgeschlossen
                        -->
                        <li
                            v-for="(status, index) in filterData.status"
                            :key="status.id"
                            class="m-c-dropdown__item"
                        >
                            <div class="m-c-form__checkfields">
                                <input
                                    :id="`checkbox-state-${index + 1}`"
                                    type="checkbox"
                                    name="checkbox-state"
                                    :checked="
                                        appliedFilterIDs.status.indexOf(
                                            status.id
                                        ) > -1
                                            ? `checked`
                                            : false
                                    "
                                    v-on:change="
                                        setFilter({
                                            filter: `status`,
                                            filterID: status.id,
                                            filterLabel: status.label,
                                            checked: $event.target.checked,
                                        })
                                    "
                                />
                                <label
                                    v-if="status.id == 1"
                                    :for="`checkbox-state-${index + 1}`"
                                    >{{ $t.message("statusOngoing") }}</label
                                >
                                <label
                                    v-if="status.id == 2"
                                    :for="`checkbox-state-${index + 1}`"
                                    >{{ $t.message("statusCompleted") }}</label
                                >
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- search field -->
            <div class="m-c-form__group">
                <label class="m-c-form__label u-typo:bold" for="search">
                    {{ $t.message("freeSearch") }}:
                </label>
                <div class="m-c-form__input-container">
                    <input
                        class="m-c-form__input"
                        id="search"
                        type="text"
                        name="search-name"
                        :placeholder="$t.message('freeSearch')"
                        @focus="keyUp()"
                        v-model="search"
                        v-on:keyup="filterSearch()"
                    />
                    <i
                        class="o-icon-font o-icon-font--arrow-right"
                        aria-hidden="true"
                    ></i>
                </div>
            </div>

            <!-- reset filter -->
            <div class="m-c-form__group">
                <button class="c-link" type="button" @click="resetFilters()">
                    {{ $t.message("resetFilter") }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import Filter from "./component.filter";

export default {
    name: "ListFilter",
    extends: Filter,
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
